import { toast } from "react-toastify";
import i18next from "i18next";

const MAX_ERROR_ARGS = 10;

/**
 * Backend error args are positional ({{0}}, {{1}}, ...). Missing ones default to "" so that messages
 * with an optional location (e.g. errors saved before line numbers were added) don't show a raw "{{1}}".
 */
export const toI18nParams = (args) => {
  const params = {};
  for (let i = 0; i < MAX_ERROR_ARGS; i++) {
    params[i] = args?.[i] ?? "";
  }
  return params;
};

/**
 * Short non-blocking warnings returned with a successful import (e.g. stock balance or repack mismatches).
 * They stay open until closed, as before.
 */
export const displayImportWarning = (message) => {
  toast.error(message, { autoClose: false, style: { whiteSpace: "pre-line" } });
};

export const displayError = (error) => {
  const errors = error?.response?.data?.errors;
  const errorTitle = errors ? Object.keys(errors)[0] : undefined;

  const message = errorTitle
    ? i18next.t(errorTitle, toI18nParams(errors[errorTitle]))
    : i18next.t("INTERNAL_SERVER_ERROR");

  // Detailed (multi-line) errors list the problematic records of the uploaded file,
  // so keep the line breaks and leave the toast open until the user closes it.
  const isDetailed = message.includes("\n");

  toast.error(message, {
    autoClose: isDetailed ? false : 10000,
    style: isDetailed ? { whiteSpace: "pre-line" } : undefined,
  });
};
